import { CUSTOM_COUNTERTOPS, CONFIGURABLE_BLINDS } from './constants';

export const isBuildAndBuyProduct = (product) => {
  const { identifiers } = product || {};
  const customExperience = product?.info?.globalCustomConfigurator?.customExperience;
  const isCountertopCustomExperience = customExperience === CUSTOM_COUNTERTOPS;
  return identifiers?.productType === CONFIGURABLE_BLINDS && !isCountertopCustomExperience;
};

export const hideViewSimilarIcon = (product) => {
  if (!product) return false;
  const { info = {}, bundleFlag } = product;
  return info?.isGenericProduct || bundleFlag || isBuildAndBuyProduct(product);
};